<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-row>
    <v-col
      cols="12"
      md="4"
    >
      <v-text-field
        id="address_is_cmra"
        v-model="sentilinkData.address_is_cmra"
        label="Address is CMRA"
      />
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-text-field
        id="address_is_commercial"
        v-model="sentilinkData.address_is_commercial"
        label="Address is Commercial"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    sentilinkData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
